var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainPic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 467,
    height: 294,
    viewBox: "0 0 467 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9043 62.3912H103.711C103.711 62.3912 99.1162 56.1459 95.6293 56.4261C92.1423 56.7125 90.0813 60.5045 85.8036 57.9454C81.5259 55.3924 81.5259 51.314 75.4984 51.314C69.4773 51.314 65.5233 57.6963 59.7138 57.9454C50.2867 58.3563 41.4199 44.0724 28.9043 62.3912Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.883 44.0288H434.137C434.137 44.0288 430.003 38.4123 426.87 38.6676C423.738 38.9229 421.883 42.3351 418.035 40.0375C414.187 37.7398 414.187 34.0723 408.776 34.0723C403.359 34.0723 399.809 39.8071 394.585 40.0375C386.111 40.3986 378.141 27.5655 366.883 44.0288Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.686 21.7933C131.704 21.7933 136.582 16.9147 136.582 10.8967C136.582 4.8786 131.704 0 125.686 0C119.668 0 114.789 4.8786 114.789 10.8967C114.789 16.9147 119.668 21.7933 125.686 21.7933Z",
    fill: "#F0C811"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.786 20.4733H163.297V148.207H197.786V20.4733Z",
    fill: "#CDDAE3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M173.968 29.6514H170.83V139.322H173.968V29.6514Z",
    fill: "#DAE6F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M181.752 29.6514H178.613V139.322H181.752V29.6514Z",
    fill: "#DAE6F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.529 29.6514H186.391V139.322H189.529V29.6514Z",
    fill: "#DAE6F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M377.762 63.4947C380.912 59.8726 380.53 54.3825 376.908 51.2323C373.286 48.0821 367.796 48.4646 364.645 52.0868C361.495 55.7089 361.878 61.199 365.5 64.3492C369.122 67.4994 374.612 67.1168 377.762 63.4947Z",
    fill: "#BECED6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M386.247 55.9341H356.197V72.1359H386.247V55.9341Z",
    fill: "#CDDAE3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M395.158 65.8408H346.49V169.446H395.158V65.8408Z",
    fill: "#CDDAE3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 72.1359H353.646V83.6365H357.943V72.1359Z",
    fill: "#DAE6F1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M373.373 72.1359H369.076V83.6365H373.373V72.1359Z",
    fill: "#DAE6F1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M388.802 72.1359H384.506V83.6365H388.802V72.1359Z",
    fill: "#DAE6F1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 88.7984H353.646V100.299H357.943V88.7984Z",
    fill: "#DAE6F1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M373.373 88.7984H369.076V100.299H373.373V88.7984Z",
    fill: "#DAE6F1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M388.802 88.7984H384.506V100.299H388.802V88.7984Z",
    fill: "#DAE6F1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 105.455H353.646V116.955H357.943V105.455Z",
    fill: "#DAE6F1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M373.373 105.455H369.076V116.955H373.373V105.455Z",
    fill: "#DAE6F1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M388.802 105.455H384.506V116.955H388.802V105.455Z",
    fill: "#DAE6F1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 122.111H353.646V133.612H357.943V122.111Z",
    fill: "#DAE6F1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M373.373 122.111H369.076V133.612H373.373V122.111Z",
    fill: "#DAE6F1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M388.802 122.111H384.506V133.612H388.802V122.111Z",
    fill: "#DAE6F1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M397.182 136.962H343.9V142.734H397.182V136.962Z",
    fill: "#BECED6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M384.691 149.415H356.391V169.284H384.691V149.415Z",
    fill: "#DAE6F1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M100.045 81.1773C103.439 77.7827 103.439 72.279 100.045 68.8845C96.6501 65.4899 91.1465 65.4899 87.7519 68.8845C84.3573 72.279 84.3573 77.7827 87.7519 81.1773C91.1465 84.5719 96.6501 84.5719 100.045 81.1773Z",
    fill: "#BECED6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M108.923 73.1882H78.873V89.39H108.923V73.1882Z",
    fill: "#CDDAE3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M117.834 83.0948H69.166V186.7H117.834V83.0948Z",
    fill: "#CDDAE3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6187 89.39H76.3223V100.891H80.6187V89.39Z",
    fill: "#DAE6F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0483 89.39H91.752V100.891H96.0483V89.39Z",
    fill: "#DAE6F1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.478 89.39H107.182V100.891H111.478V89.39Z",
    fill: "#DAE6F1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6187 106.053H76.3223V117.553H80.6187V106.053Z",
    fill: "#DAE6F1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0483 106.053H91.752V117.553H96.0483V106.053Z",
    fill: "#DAE6F1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.478 106.053H107.182V117.553H111.478V106.053Z",
    fill: "#DAE6F1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6187 122.709H76.3223V134.21H80.6187V122.709Z",
    fill: "#DAE6F1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0483 122.709H91.752V134.21H96.0483V122.709Z",
    fill: "#DAE6F1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M111.478 122.709H107.182V134.21H111.478V122.709Z",
    fill: "#DAE6F1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6187 139.371H76.3223V150.872H80.6187V139.371Z",
    fill: "#DAE6F1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0483 139.371H91.752V150.872H96.0483V139.371Z",
    fill: "#DAE6F1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M111.478 139.371H107.182V150.872H111.478V139.371Z",
    fill: "#DAE6F1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.858 154.222H66.5762V159.994H119.858V154.222Z",
    fill: "#BECED6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.367 166.675H79.0664V186.545H107.367V166.675Z",
    fill: "#DAE6F1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0272 150.212H32.0508V207.915H70.0272V150.212Z",
    fill: "#CDDAE3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M433.928 117.64H394.363V210.511H433.928V117.64Z",
    fill: "#CDDAE3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M454.064 194.303H12.9355V230.816H454.064V194.303Z",
    fill: "#CDDAE3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.7 105.274H55.5156V230.81H114.7V105.274Z",
    fill: "#A7B7D4"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.801 105.274H114.701V230.81H139.801V105.274Z",
    fill: "#4870B2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M114.701 99.141H50.8281V105.281H114.701V99.141Z",
    fill: "#2B333F"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M144.377 99.141H114.701V105.281H144.377V99.141Z",
    fill: "#111416"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8914 143.201H63.3359V128.107C63.3359 124.365 66.3683 121.333 70.1105 121.333C73.8528 121.333 76.8852 124.365 76.8852 128.107V143.201H76.8914Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5349 141.657H61.6855V144.266H78.5349V141.657Z",
    fill: "#2B333F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5349 144.259H61.6855V145.829H78.5349V144.259Z",
    fill: "#92A6C2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M102.341 143.201H88.7852V128.107C88.7852 124.365 91.8175 121.333 95.5598 121.333C99.302 121.333 102.334 124.365 102.334 128.107V143.201H102.341Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 141.657H87.1406V144.266H103.99V141.657Z",
    fill: "#2B333F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 144.259H87.1406V145.829H103.99V144.259Z",
    fill: "#92A6C2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8914 174.938H63.3359V159.845C63.3359 156.103 66.3683 153.07 70.1105 153.07C73.8528 153.07 76.8852 156.103 76.8852 159.845V174.938H76.8914Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5349 173.388H61.6855V175.997H78.5349V173.388Z",
    fill: "#2B333F"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5349 175.997H61.6855V177.566H78.5349V175.997Z",
    fill: "#92A6C2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M102.341 174.938H88.7852V159.845C88.7852 156.103 91.8175 153.07 95.5598 153.07C99.302 153.07 102.334 156.103 102.334 159.845V174.938H102.341Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 173.388H87.1406V175.997H103.99V173.388Z",
    fill: "#2B333F"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M103.99 175.997H87.1406V177.566H103.99V175.997Z",
    fill: "#92A6C2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6367 230.81V194.303H92.3914V230.81",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M190.058 90.0189H130.873V230.81H190.058V90.0189Z",
    fill: "#A7B7D4"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M215.158 90.0189H190.059V230.81H215.158V90.0189Z",
    fill: "#4870B2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M190.059 83.8856H126.186V90.0251H190.059V83.8856Z",
    fill: "#2B333F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M219.735 83.8856H190.059V90.0251H219.735V83.8856Z",
    fill: "#111416"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M152.245 125.548H138.689V110.455C138.689 106.713 141.722 103.68 145.464 103.68C149.206 103.68 152.239 106.713 152.239 110.455V125.548H152.245Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 123.998H137.045V126.607H153.894V123.998Z",
    fill: "#2B333F"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 126.607H137.045V128.176H153.894V126.607Z",
    fill: "#92A6C2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M177.694 125.548H164.139V110.455C164.139 106.713 167.171 103.68 170.913 103.68C174.656 103.68 177.688 106.713 177.688 110.455V125.548H177.694Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 123.998H162.494V126.607H179.343V123.998Z",
    fill: "#2B333F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 126.607H162.494V128.176H179.343V126.607Z",
    fill: "#92A6C2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M152.245 157.286H138.689V142.192C138.689 138.45 141.722 135.417 145.464 135.417C149.206 135.417 152.239 138.45 152.239 142.192V157.286H152.245Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 155.735H137.045V158.344H153.894V155.735Z",
    fill: "#2B333F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 158.344H137.045V159.913H153.894V158.344Z",
    fill: "#92A6C2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.694 157.286H164.139V142.192C164.139 138.45 167.171 135.417 170.913 135.417C174.656 135.417 177.688 138.45 177.688 142.192V157.286H177.694Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 155.735H162.494V158.344H179.343V155.735Z",
    fill: "#2B333F"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 158.344H162.494V159.913H179.343V158.344Z",
    fill: "#92A6C2"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M152.245 189.023H138.689V173.929C138.689 170.187 141.722 167.155 145.464 167.155C149.206 167.155 152.239 170.187 152.239 173.929V189.023H152.245Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 187.472H137.045V190.081H153.894V187.472Z",
    fill: "#2B333F"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M153.894 190.081H137.045V191.651H153.894V190.081Z",
    fill: "#92A6C2"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M177.694 189.023H164.139V173.929C164.139 170.187 167.171 167.155 170.913 167.155C174.656 167.155 177.688 170.187 177.688 173.929V189.023H177.694Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 187.472H162.494V190.081H179.343V187.472Z",
    fill: "#2B333F"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M179.343 190.081H162.494V191.651H179.343V190.081Z",
    fill: "#92A6C2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M190.058 72.9019H130.873V83.8857H190.058V72.9019Z",
    fill: "#A7B7D4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M212.542 72.9019H190.139V83.8857H212.542V72.9019Z",
    fill: "#4870B2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M170.91 56.1708H153.887V73.1945H170.91V56.1708Z",
    fill: "#A7B7D4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M212.535 56.1708H170.822V73.1945H212.535V56.1708Z",
    fill: "#4870B2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M294.876 36.8307H212.541V230.81H294.876V36.8307Z",
    fill: "#A7B7D4"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M336.838 36.8307H294.877V230.81H336.838V36.8307Z",
    fill: "#4870B2"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M294.87 28.294H206.016V36.8308H294.87V28.294Z",
    fill: "#2B333F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M343.202 28.294H294.877V36.8308H343.202V28.294Z",
    fill: "#111416"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 52.8768H221.377V74.7449H234.932V52.8768Z",
    fill: "#DAE6F1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M233.027 52.6963L221.377 64.2405V68.2069L234.932 54.0724L233.027 52.6963Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M234.933 56.4323L221.732 70.1994V72.9018L235.282 58.7673L234.933 56.4323Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M235.51 75.6353H220.797V51.9927H235.517V75.6353H235.51ZM221.961 73.8545H234.346V53.7673H221.961V73.8545Z",
    fill: "#5E7391"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 73.1945H219.732V76.7001H236.582V73.1945Z",
    fill: "#2B333F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 62.7462H221.377V64.2406H234.932V62.7462Z",
    fill: "#5E7391"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 76.7001H219.732V78.2692H236.582V76.7001Z",
    fill: "#92A6C2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 52.8768H246.242V74.7449H259.798V52.8768Z",
    fill: "#DAE6F1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M257.892 52.6963L246.242 64.2405V68.2069L259.798 54.0724L257.892 52.6963Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M259.798 56.4323L246.598 70.1994V72.9018L260.147 58.7673L259.798 56.4323Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M260.382 75.6353H245.662V51.9927H260.382V75.6353ZM246.826 73.8545H259.211V53.7673H246.826V73.8545Z",
    fill: "#5E7391"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 73.1945H244.598V76.7001H261.447V73.1945Z",
    fill: "#2B333F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 62.7462H246.242V64.2406H259.798V62.7462Z",
    fill: "#5E7391"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 76.7001H244.598V78.2692H261.447V76.7001Z",
    fill: "#92A6C2"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 52.8768H271.105V74.7449H284.661V52.8768Z",
    fill: "#DAE6F1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.756 52.6963L271.105 64.2405V68.2069L284.661 54.0724L282.756 52.6963Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M284.661 56.4323L271.461 70.1995V72.9018L285.01 58.7673L284.661 56.4323Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M285.245 75.6353H270.525V51.9927H285.245V75.6353ZM271.69 73.8545H284.075V53.7673H271.69V73.8545Z",
    fill: "#5E7391"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 73.1945H269.461V76.7001H286.31V73.1945Z",
    fill: "#2B333F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 62.7462H271.105V64.2406H284.661V62.7462Z",
    fill: "#5E7391"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 76.7001H269.461V78.2692H286.31V76.7001Z",
    fill: "#92A6C2"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 89.2406H221.377V111.109H234.932V89.2406Z",
    fill: "#DAE6F1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M233.027 89.06L221.377 100.604V104.571L234.932 90.4361L233.027 89.06Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M234.933 92.796L221.732 106.563V109.266L235.282 95.131L234.933 92.796Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M235.51 111.999H220.797V88.3564H235.517V111.999H235.51ZM221.961 110.218H234.346V90.131H221.961V110.218Z",
    fill: "#5E7391"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 109.558H219.732V113.064H236.582V109.558Z",
    fill: "#2B333F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 99.1036H221.377V100.598H234.932V99.1036Z",
    fill: "#5E7391"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 113.064H219.732V114.633H236.582V113.064Z",
    fill: "#92A6C2"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 89.2406H246.242V111.109H259.798V89.2406Z",
    fill: "#DAE6F1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M257.892 89.06L246.242 100.604V104.571L259.798 90.4361L257.892 89.06Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M259.798 92.796L246.598 106.563V109.266L260.147 95.131L259.798 92.796Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M260.382 111.999H245.662V88.3564H260.382V111.999ZM246.826 110.218H259.211V90.131H246.826V110.218Z",
    fill: "#5E7391"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 109.558H244.598V113.064H261.447V109.558Z",
    fill: "#2B333F"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 99.1036H246.242V100.598H259.798V99.1036Z",
    fill: "#5E7391"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 113.064H244.598V114.633H261.447V113.064Z",
    fill: "#92A6C2"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 89.2406H271.105V111.109H284.661V89.2406Z",
    fill: "#DAE6F1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.756 89.06L271.105 100.604V104.571L284.661 90.4361L282.756 89.06Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M284.661 92.796L271.461 106.563V109.266L285.01 95.131L284.661 92.796Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M285.245 111.999H270.525V88.3564H285.245V111.999ZM271.69 110.218H284.075V90.131H271.69V110.218Z",
    fill: "#5E7391"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 109.558H269.461V113.064H286.31V109.558Z",
    fill: "#2B333F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 99.1036H271.105V100.598H284.661V99.1036Z",
    fill: "#5E7391"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 113.064H269.461V114.633H286.31V113.064Z",
    fill: "#92A6C2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 125.604H221.377V147.472H234.932V125.604Z",
    fill: "#DAE6F1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M233.027 125.424L221.377 136.968V140.934L234.932 126.8L233.027 125.424Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M234.933 129.16L221.732 142.927V145.629L235.282 131.495L234.933 129.16Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M235.51 148.363H220.797V124.72H235.517V148.363H235.51ZM221.961 146.582H234.346V126.495H221.961V146.582Z",
    fill: "#5E7391"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 145.922H219.732V149.428H236.582V145.922Z",
    fill: "#2B333F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 135.467H221.377V136.962H234.932V135.467Z",
    fill: "#5E7391"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 149.428H219.732V150.997H236.582V149.428Z",
    fill: "#92A6C2"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 125.604H246.242V147.472H259.798V125.604Z",
    fill: "#DAE6F1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M257.892 125.424L246.242 136.968V140.934L259.798 126.8L257.892 125.424Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M259.798 129.16L246.598 142.927V145.629L260.147 131.495L259.798 129.16Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M260.382 148.363H245.662V124.72H260.382V148.363ZM246.826 146.582H259.211V126.495H246.826V146.582Z",
    fill: "#5E7391"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 145.922H244.598V149.428H261.447V145.922Z",
    fill: "#2B333F"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 135.467H246.242V136.962H259.798V135.467Z",
    fill: "#5E7391"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 149.428H244.598V150.997H261.447V149.428Z",
    fill: "#92A6C2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 125.604H271.105V147.472H284.661V125.604Z",
    fill: "#DAE6F1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.756 125.424L271.105 136.968V140.934L284.661 126.8L282.756 125.424Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M284.661 129.16L271.461 142.927V145.629L285.01 131.495L284.661 129.16Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M285.245 148.363H270.525V124.72H285.245V148.363ZM271.69 146.582H284.075V126.495H271.69V146.582Z",
    fill: "#5E7391"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 145.922H269.461V149.428H286.31V145.922Z",
    fill: "#2B333F"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 135.467H271.105V136.962H284.661V135.467Z",
    fill: "#5E7391"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 149.428H269.461V150.997H286.31V149.428Z",
    fill: "#92A6C2"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 161.968H221.377V183.836H234.932V161.968Z",
    fill: "#DAE6F1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M233.027 161.788L221.377 173.326V177.292L234.932 163.164L233.027 161.788Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M234.933 165.524L221.732 179.284V181.993L235.282 167.859L234.933 165.524Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M235.51 184.72H220.797V161.078H235.517V184.72H235.51ZM221.961 182.946H234.346V162.859H221.961V182.946Z",
    fill: "#5E7391"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 182.286H219.732V185.791H236.582V182.286Z",
    fill: "#2B333F"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M234.932 171.831H221.377V173.326H234.932V171.831Z",
    fill: "#5E7391"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M236.582 185.791H219.732V187.36H236.582V185.791Z",
    fill: "#92A6C2"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 161.968H246.242V183.836H259.798V161.968Z",
    fill: "#DAE6F1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M257.892 161.788L246.242 173.326V177.292L259.798 163.164L257.892 161.788Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M259.798 165.524L246.598 179.284V181.993L260.147 167.859L259.798 165.524Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M260.382 184.72H245.662V161.078H260.382V184.72ZM246.826 182.946H259.211V162.859H246.826V182.946Z",
    fill: "#5E7391"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 182.286H244.598V185.791H261.447V182.286Z",
    fill: "#2B333F"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M259.798 171.831H246.242V173.326H259.798V171.831Z",
    fill: "#5E7391"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M261.447 185.791H244.598V187.36H261.447V185.791Z",
    fill: "#92A6C2"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 161.968H271.105V183.836H284.661V161.968Z",
    fill: "#DAE6F1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M282.756 161.788L271.105 173.326V177.292L284.661 163.164L282.756 161.788Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M284.661 165.523L271.461 179.284V181.993L285.01 167.858L284.661 165.523Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M285.245 184.72H270.525V161.078H285.245V184.72ZM271.69 182.946H284.075V162.859H271.69V182.946Z",
    fill: "#5E7391"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 182.286H269.461V185.791H286.31V182.286Z",
    fill: "#2B333F"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M284.661 171.831H271.105V173.326H284.661V171.831Z",
    fill: "#5E7391"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M286.31 185.791H269.461V187.36H286.31V185.791Z",
    fill: "#92A6C2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M238.693 230.81V202.884H263.183V230.81",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M385.667 90.0189H326.482V230.81H385.667V90.0189Z",
    fill: "#A7B7D4"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M410.768 90.0189H385.668V230.81H410.768V90.0189Z",
    fill: "#4870B2"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M385.668 83.8856H321.795V90.0251H385.668V83.8856Z",
    fill: "#2B333F"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M415.344 83.8856H385.668V90.0251H415.344V83.8856Z",
    fill: "#111416"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M347.854 125.548H334.299V110.455C334.299 106.713 337.331 103.68 341.073 103.68C344.816 103.68 347.848 106.713 347.848 110.455V125.548H347.854Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 123.998H332.654V126.607H349.504V123.998Z",
    fill: "#2B333F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 126.607H332.654V128.176H349.504V126.607Z",
    fill: "#92A6C2"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M373.304 125.548H359.748V110.455C359.748 106.713 362.78 103.68 366.523 103.68C370.265 103.68 373.297 106.713 373.297 110.455V125.548H373.304Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 123.998H358.104V126.607H374.953V123.998Z",
    fill: "#2B333F"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 126.607H358.104V128.176H374.953V126.607Z",
    fill: "#92A6C2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M347.854 157.286H334.299V142.192C334.299 138.45 337.331 135.418 341.073 135.418C344.816 135.418 347.848 138.45 347.848 142.192V157.286H347.854Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 155.735H332.654V158.344H349.504V155.735Z",
    fill: "#2B333F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 158.344H332.654V159.913H349.504V158.344Z",
    fill: "#92A6C2"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M373.304 157.286H359.748V142.192C359.748 138.45 362.78 135.417 366.523 135.417C370.265 135.417 373.297 138.45 373.297 142.192V157.286H373.304Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 155.735H358.104V158.344H374.953V155.735Z",
    fill: "#2B333F"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 158.344H358.104V159.913H374.953V158.344Z",
    fill: "#92A6C2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M347.854 189.023H334.299V173.929C334.299 170.187 337.331 167.155 341.073 167.155C344.816 167.155 347.848 170.187 347.848 173.929V189.023H347.854Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 187.472H332.654V190.081H349.504V187.472Z",
    fill: "#2B333F"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M349.504 190.081H332.654V191.651H349.504V190.081Z",
    fill: "#92A6C2"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M373.304 189.023H359.748V173.929C359.748 170.187 362.78 167.155 366.523 167.155C370.265 167.155 373.297 170.187 373.297 173.929V189.023H373.304Z",
    stroke: "#DAE6F1",
    strokeWidth: 0.688669,
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 187.472H358.104V190.081H374.953V187.472Z",
    fill: "#2B333F"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M374.953 190.081H358.104V191.651H374.953V190.081Z",
    fill: "#92A6C2"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M367.719 217.522C361.648 217.522 356.729 212.603 356.729 206.532V189.415C356.729 183.344 361.648 178.425 367.719 178.425C373.79 178.425 378.709 183.344 378.709 189.415V206.532C378.702 212.603 373.783 217.522 367.719 217.522Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M367.719 189.87V228.363",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M367.719 203.077L373.391 197.068",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M441.049 189.361C443.574 178.817 437.073 168.221 426.529 165.696C415.984 163.171 405.389 169.672 402.863 180.216C400.338 190.761 406.839 201.356 417.384 203.882C427.928 206.407 438.524 199.906 441.049 189.361Z",
    fill: "#7CACDB"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M421.951 177.964V225.978",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M421.951 191.171L427.624 185.162",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5194 208.649C66.3622 208.649 75.1521 199.86 75.1521 189.017C75.1521 178.174 66.3622 169.384 55.5194 169.384C44.6766 169.384 35.8867 178.174 35.8867 189.017C35.8867 199.86 44.6766 208.649 55.5194 208.649Z",
    fill: "#7CACDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5195 182.192V230.212",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5195 195.405L61.192 189.39",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M114.707 219.976C108.636 219.976 103.717 215.057 103.717 208.986V191.869C103.717 185.798 108.636 180.878 114.707 180.878C120.778 180.878 125.697 185.798 125.697 191.869V208.986C125.691 215.057 120.772 219.976 114.707 219.976Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M114.707 192.317V230.81",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M114.707 205.524L120.38 199.515",
    stroke: "#2B333F",
    strokeWidth: 0.891223,
    strokeMiterlimit: 10
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M326.488 217.529C318.636 217.529 312.13 223.288 310.959 230.816H342.018C340.853 223.288 334.346 217.529 326.488 217.529Z",
    fill: "#7CACDB"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8828 217.529C28.031 217.529 21.5241 223.288 20.3535 230.816H51.4121C50.2477 223.288 43.7409 217.529 35.8828 217.529Z",
    fill: "#7CACDB"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M421.953 217.529C414.101 217.529 407.594 223.288 406.424 230.816H437.482C436.312 223.288 429.805 217.529 421.953 217.529Z",
    fill: "#7CACDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0451 222.908C52.3751 222.908 48.5021 226.333 47.8047 230.81H66.2854C65.588 226.333 61.7151 222.908 57.0451 222.908Z",
    fill: "#7CACDB"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M130.877 222.908C126.207 222.908 122.334 226.333 121.637 230.81H140.117C139.42 226.333 135.547 222.908 130.877 222.908Z",
    fill: "#7CACDB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M373.89 221.651C368.473 221.651 363.983 225.623 363.174 230.816H384.6C383.79 225.623 379.307 221.651 373.89 221.651Z",
    fill: "#7CACDB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M467 230.517H0V293.986H467V230.517Z",
    fill: "#DAE6F1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M467 230.517H0V245.318H467V230.517Z",
    fill: "#B9C9E0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M172.994 272.367L285.996 271.638C291.513 271.582 295.94 267.055 295.884 261.539L295.915 106.806C295.859 101.289 291.332 96.862 285.815 96.918L172.814 97.6466C167.297 97.7026 162.87 102.229 162.926 107.746L162.895 262.479C162.957 268.002 167.477 272.429 172.994 272.367Z",
    fill: "#1C1C1C"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M175.385 266.72L283.648 266.035C287.957 265.991 291.406 262.461 291.363 258.152L291.425 109.297C291.382 104.988 287.851 101.539 283.542 101.582L175.279 102.267C170.97 102.311 167.521 105.841 167.564 110.15L167.502 259.005C167.552 263.314 171.076 266.769 175.385 266.72Z",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M167.502 169.452H202.087C207.749 169.452 212.334 165.21 212.334 159.983V102.204",
    stroke: "#DAE6F1",
    strokeWidth: 3.60873,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M234.75 102.204V136.973C234.75 141.501 238.694 145.168 243.563 145.168H290.79",
    stroke: "#DAE6F1",
    strokeWidth: 3.60873,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M167.502 190L291.413 190",
    stroke: "#DAE6F1",
    strokeWidth: 3.60873,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M277.024 177.254H225.081C223.686 177.254 222.553 176.121 222.553 174.726V161.663C222.553 160.268 223.686 159.135 225.081 159.135H277.024C278.418 159.135 279.552 160.268 279.552 161.663V174.726C279.558 176.121 278.425 177.254 277.024 177.254Z",
    fill: "#C82021"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M167.502 211.171H190.53C195.352 211.171 199.258 214.282 199.258 218.122V265.966",
    stroke: "#DAE6F1",
    strokeWidth: 3.60873,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M236.617 265.966V219.825C236.617 215.044 241.131 211.171 246.703 211.171H314.451",
    stroke: "#DAE6F1",
    strokeWidth: 3.60873,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M225.142 237.547C225.702 236.489 226.026 235.281 226.026 233.992C226.026 229.808 222.633 226.42 218.454 226.42C214.27 226.42 210.883 229.814 210.883 233.992C210.883 235.275 211.207 236.489 211.767 237.547L211.786 237.578C211.798 237.597 211.804 237.616 211.817 237.634L216.923 246.906C217.589 248.114 219.326 248.114 219.986 246.906L225.092 237.634C225.105 237.616 225.111 237.597 225.123 237.578L225.142 237.547Z",
    fill: "#C82021"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M197.683 137.914C198.243 136.856 198.567 135.648 198.567 134.359C198.567 130.175 195.174 126.787 190.995 126.787C186.817 126.787 183.424 130.175 183.424 134.359C183.424 135.642 183.748 136.856 184.308 137.914L184.327 137.946C184.339 137.964 184.345 137.983 184.358 138.002L189.464 147.273C190.13 148.481 191.867 148.481 192.527 147.273L197.633 138.002C197.646 137.983 197.652 137.964 197.664 137.946L197.683 137.914Z",
    fill: "#C82021"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M175.859 274.527L166.886 293.986H132.166L152.216 262.51L175.859 274.527Z",
    fill: "#D3825E"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M183.568 192.678C182.796 192.105 181.488 191.756 180.585 191.669C176.357 191.283 173.804 194.129 172.491 204.228C170.897 216.483 172.354 226.233 165.218 228.519C164.159 228.861 164.271 228.774 162.895 229.092V182.609C156.544 193.338 150.068 207.883 145.535 215.169C142.627 219.845 141.258 225.443 142.472 230.816C149.377 261.377 149.035 286.713 157.839 289.11C157.839 289.11 186.351 288.239 186.351 231.103C186.351 231.103 186.669 202.348 185.392 195.934C184.969 193.867 184.11 193.07 183.568 192.678Z",
    fill: "#D3825E"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M177.004 202.348C177.004 202.348 176.244 193.656 181.275 193.656C185.615 193.656 184.862 202.348 184.862 202.348H177.004Z",
    fill: "#E3997D"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M162.893 229.091L157.457 230.181L162.893 202.311V229.091Z",
    fill: "#BE6A47"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M311.366 223.898L298.838 198.002C297.487 195.1 294.056 193.824 291.136 195.137C288.228 196.445 286.908 199.845 288.16 202.778L299.629 228.133L311.366 223.898Z",
    fill: "#D3825E"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M291.136 195.138C291.136 195.138 276.459 206.109 261.216 209.459C259.89 209.751 258.938 210.91 258.938 212.267C258.938 213.718 260.021 214.957 261.466 215.119C267.163 215.766 279.716 217.224 296.397 203.861L291.136 195.138Z",
    fill: "#D3825E"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M267.413 207.653C267.413 207.653 269.256 210.835 264.505 211.57C261.603 212.018 260.514 211.265 260.109 210.605C259.879 210.237 260.097 209.745 260.52 209.646L267.413 207.653Z",
    fill: "#E3997D"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M320.437 224.92L307.909 199.023C306.557 196.121 303.127 194.845 300.206 196.159C297.298 197.466 295.978 200.866 297.23 203.799L308.699 229.154L320.437 224.92Z",
    fill: "#D3825E"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M329.136 229.141C329.136 229.141 320.861 208.263 316.534 201.669C314.778 198.992 311.752 197.491 308.831 198.805C305.923 200.113 304.603 203.512 305.855 206.445L317.324 231.8L329.136 229.141Z",
    fill: "#D3825E"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M283.494 229.957C283.339 229.895 283.189 229.826 283.04 229.745C281.657 228.942 272.822 224.172 265.331 222.535C260.966 221.582 257.193 223.189 255.126 225.331C253.357 227.174 254.609 229.907 257.087 230.511C265.312 232.497 267.704 235.356 271.77 238.282C280.91 244.87 285.53 266.719 309.933 268.014C311.409 268.095 323.196 267.585 323.563 266.153L318.233 246.028C318.631 244.496 317.81 242.915 316.334 242.361L283.494 229.957Z",
    fill: "#D3825E"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M283.252 229.864C283.252 229.864 286.259 229.752 285.643 224.235C285.643 224.235 306.272 215.966 324.037 217.647C324.037 217.647 334.454 240.318 342.829 263.114L301.353 264.876L283.252 229.864Z",
    fill: "#D3825E"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M286.515 227.417C286.515 227.417 284.946 213.936 266.776 180.05C265.736 178.114 261.882 170.15 265.587 167.653C267.959 166.053 270.537 167.939 272.455 170.237C273.557 171.551 276.428 176.451 277.331 177.921C287.436 194.39 302.636 222.006 302.636 222.006L286.515 227.417Z",
    fill: "#D3825E"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M288.742 196.812L300.822 218.6",
    stroke: "#BE6A47",
    strokeWidth: 0.632816,
    strokeMiterlimit: 10
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M298.508 197.311L308.035 215.063",
    stroke: "#BE6A47",
    strokeWidth: 0.632816,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M308.033 199.235L315.188 212.392",
    stroke: "#BE6A47",
    strokeWidth: 0.632816,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M277.436 203.68L281.327 212.964",
    stroke: "#BE6A47",
    strokeWidth: 0.632816,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M276.022 175.779C276.022 175.779 271.209 177.609 268.918 173.649C267.467 171.146 267.672 169.284 268.258 168.288C268.855 167.267 270.2 167.578 270.462 167.865C272.299 169.789 274.733 173.842 276.022 175.779Z",
    fill: "#E3997D"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M257.094 230.499C257.094 230.499 257.212 226.75 261.409 228.027C261.409 228.027 264.871 229.11 265.562 230.038L264.329 233.114C264.329 233.114 262.81 232.167 257.094 230.499Z",
    fill: "#E3997D"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M283.252 229.864C283.252 229.864 286.253 229.639 285.643 224.235C285.643 224.235 288.19 229.689 287.903 234.839C287.897 234.832 285.027 230.841 283.252 229.864Z",
    fill: "#BE6A47"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M342.829 263.108L360.014 293.986H322.953L308.414 257.877L342.829 263.108Z",
    fill: "#D3825E"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M288.744 93.6677H288.738C290.681 90.0189 291.795 85.8533 291.795 81.4261C291.795 67.0238 280.12 55.3488 265.718 55.3488C251.316 55.3488 239.641 67.0238 239.641 81.4261C239.641 85.8533 240.749 90.0127 242.698 93.6677H242.692L242.748 93.7736C242.785 93.8421 242.822 93.9043 242.854 93.9728L260.438 125.903C262.729 130.063 268.707 130.063 270.998 125.903L288.582 93.9728C288.62 93.9043 288.657 93.8421 288.688 93.7736L288.744 93.6677Z",
    fill: "#C82021"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M276.715 74.9628L266.285 66.9304C265.893 66.6129 265.314 66.6129 264.916 66.9304L260.887 70.0126V67.7212C260.887 67.4037 260.625 67.167 260.333 67.167H258.172C257.855 67.167 257.618 67.4286 257.618 67.7212V72.5407L254.455 74.9379C253.614 75.598 254.087 76.9678 255.14 76.9678H255.613V90.6291H275.551V76.9678H276.024C277.114 76.9616 277.562 75.5917 276.715 74.9628ZM268.023 87.4971H263.178V82.4161C263.178 81.0712 264.256 79.994 265.601 79.994C266.946 79.994 268.023 81.0712 268.023 82.4161V87.4971Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M254.891 94.9442L255.57 96.7686C255.588 96.8122 255.626 96.8434 255.675 96.8434L257.618 96.9243C257.724 96.9305 257.768 97.0613 257.687 97.1298L256.161 98.3378C256.124 98.3689 256.111 98.4125 256.124 98.4561L256.647 100.33C256.678 100.436 256.56 100.517 256.472 100.455L254.853 99.3776C254.816 99.3527 254.766 99.3527 254.723 99.3776L253.104 100.455C253.017 100.511 252.898 100.43 252.929 100.33L253.452 98.4561C253.465 98.4125 253.452 98.3627 253.415 98.3378L251.89 97.1298C251.809 97.0613 251.852 96.9305 251.958 96.9243L253.901 96.8434C253.944 96.8434 253.988 96.8122 254.007 96.7686L254.685 94.9442C254.716 94.8446 254.853 94.8446 254.891 94.9442Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M262.102 94.9442L262.78 96.7686C262.799 96.8122 262.837 96.8434 262.886 96.8434L264.829 96.9243C264.935 96.9305 264.978 97.0613 264.898 97.1298L263.372 98.3378C263.335 98.3689 263.322 98.4125 263.335 98.4561L263.858 100.33C263.889 100.436 263.771 100.517 263.683 100.455L262.064 99.3776C262.027 99.3527 261.977 99.3527 261.934 99.3776L260.315 100.455C260.228 100.511 260.109 100.43 260.14 100.33L260.663 98.4561C260.676 98.4125 260.663 98.3627 260.626 98.3378L259.101 97.1298C259.02 97.0613 259.063 96.9305 259.169 96.9243L261.112 96.8434C261.155 96.8434 261.199 96.8122 261.218 96.7686L261.896 94.9442C261.921 94.8446 262.064 94.8446 262.102 94.9442Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M269.306 94.9442L269.985 96.7686C270.004 96.8122 270.041 96.8434 270.091 96.8434L272.034 96.9243C272.14 96.9305 272.183 97.0613 272.102 97.1298L270.577 98.3378C270.539 98.3689 270.527 98.4125 270.539 98.4561L271.062 100.33C271.094 100.436 270.975 100.517 270.888 100.455L269.269 99.3776C269.232 99.3527 269.182 99.3527 269.145 99.3776L267.526 100.455C267.438 100.511 267.32 100.43 267.351 100.33L267.874 98.4561C267.887 98.4125 267.874 98.3627 267.837 98.3378L266.311 97.1298C266.23 97.0613 266.274 96.9305 266.38 96.9243L268.323 96.8434C268.366 96.8434 268.41 96.8122 268.429 96.7686L269.107 94.9442C269.126 94.8446 269.269 94.8446 269.306 94.9442Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M276.51 94.9442L277.188 96.7686C277.207 96.8122 277.244 96.8434 277.294 96.8434L279.237 96.9243C279.343 96.9305 279.386 97.0613 279.305 97.1298L277.78 98.3378C277.742 98.3689 277.73 98.4125 277.742 98.4561L278.266 100.33C278.297 100.436 278.178 100.517 278.091 100.455L276.472 99.3776C276.435 99.3527 276.385 99.3527 276.348 99.3776L274.729 100.455C274.642 100.511 274.523 100.43 274.554 100.33L275.077 98.4561C275.09 98.4125 275.077 98.3627 275.04 98.3378L273.515 97.1298C273.434 97.0613 273.477 96.9305 273.583 96.9243L275.526 96.8434C275.569 96.8434 275.613 96.8122 275.632 96.7686L276.31 94.9442C276.329 94.8446 276.472 94.8446 276.51 94.9442Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M239.052 170V169.033H239.417V170H239.052ZM237.083 166.695C238.047 166.695 238.589 167.475 238.709 169.033H239.144V170H238.647C238.519 170.618 238.223 171.131 237.76 171.538C237.297 171.948 236.673 172.228 235.888 172.377L235.562 171.534C236.169 171.419 236.654 171.228 237.017 170.958C237.38 170.691 237.626 170.372 237.755 170H237.237C236.689 170 236.27 169.884 235.98 169.653C235.693 169.421 235.549 169.074 235.549 168.611C235.549 168.389 235.58 168.165 235.642 167.939C235.703 167.713 235.795 167.507 235.918 167.319C236.044 167.132 236.204 166.981 236.397 166.867C236.591 166.752 236.819 166.695 237.083 166.695ZM237.817 169.033C237.779 168.532 237.694 168.176 237.562 167.965C237.433 167.754 237.26 167.649 237.043 167.649C236.894 167.649 236.775 167.703 236.688 167.812C236.603 167.917 236.541 168.043 236.503 168.189C236.468 168.336 236.45 168.469 236.45 168.589C236.45 168.748 236.5 168.862 236.6 168.932C236.702 169 236.9 169.033 237.193 169.033H237.817ZM241.416 171.332L242.119 170.633L242.822 171.332L242.119 172.035L241.416 171.332ZM244.883 168.304C244.749 168.318 244.614 168.342 244.479 168.374C244.347 168.406 244.192 168.462 244.013 168.541C244.031 168.705 244.127 168.828 244.303 168.91C244.479 168.992 244.75 169.033 245.116 169.033H245.354V170H245.099C244.58 170 244.166 169.918 243.855 169.754C243.547 169.59 243.355 169.316 243.279 168.932C242.743 169.222 242.2 169.473 241.649 169.684C241.101 169.895 240.533 170 239.944 170H239.241V169.033H239.957C240.314 169.033 240.647 168.995 240.955 168.919C241.265 168.843 241.58 168.734 241.899 168.594C242.219 168.453 242.572 168.283 242.958 168.084L243.288 167.913C243.229 167.895 243.159 167.869 243.077 167.833C242.998 167.795 242.856 167.735 242.651 167.653C242.352 167.53 242.107 167.435 241.917 167.368C241.727 167.3 241.589 167.267 241.504 167.267C241.354 167.267 241.207 167.312 241.06 167.403C240.917 167.491 240.793 167.601 240.691 167.732L240.528 167.943L239.715 167.539L239.83 167.346C240.017 167.032 240.256 166.782 240.546 166.594C240.839 166.404 241.16 166.309 241.508 166.309C241.705 166.309 241.917 166.35 242.146 166.432C242.374 166.511 242.619 166.613 242.879 166.739C243.199 166.895 243.473 167.019 243.701 167.113C243.93 167.204 244.136 167.271 244.321 167.315C244.508 167.359 244.699 167.385 244.892 167.394L244.883 168.304ZM248.729 170H248.623C248.33 170 248.087 169.952 247.894 169.855C247.703 169.758 247.548 169.615 247.428 169.424C247.261 169.618 247.041 169.763 246.769 169.859C246.499 169.953 246.188 170 245.837 170H245.182V169.033H245.846C246.273 169.033 246.563 168.978 246.716 168.866C246.871 168.755 246.95 168.537 246.953 168.211C246.953 168.056 246.949 167.895 246.94 167.728C246.931 167.558 246.922 167.397 246.914 167.245L247.81 167.144L247.885 168.321C247.899 168.567 247.965 168.748 248.083 168.862C248.203 168.976 248.386 169.033 248.632 169.033H248.729V170ZM246.703 165.663L247.366 164.999L248.034 165.663L247.366 166.335L246.703 165.663ZM245.235 165.663L245.898 164.999L246.566 165.663L245.898 166.335L245.235 165.663ZM253.712 169.033C253.882 169.033 254.011 168.97 254.099 168.844C254.189 168.718 254.235 168.507 254.235 168.211C254.235 168.115 254.23 167.979 254.222 167.803C254.213 167.624 254.201 167.439 254.187 167.249L255.087 167.144L255.162 168.321C255.194 168.796 255.436 169.033 255.887 169.033H256.019V170H255.896C255.626 170 255.392 169.956 255.193 169.868C254.997 169.777 254.85 169.635 254.753 169.442C254.522 169.814 254.176 170 253.716 170C253.224 170 252.865 169.81 252.64 169.429C252.329 169.81 251.929 170 251.44 170C250.877 169.994 250.488 169.805 250.271 169.433C250.001 169.811 249.531 170 248.86 170H248.557V169.033H248.869C249.212 169.033 249.459 168.976 249.612 168.862C249.767 168.745 249.845 168.525 249.845 168.203C249.845 168.132 249.839 168.015 249.827 167.851C249.818 167.687 249.808 167.517 249.796 167.341L250.693 167.236L250.772 168.321C250.79 168.538 250.853 168.711 250.961 168.84C251.069 168.969 251.232 169.033 251.449 169.033C251.712 169.033 251.898 168.966 252.007 168.831C252.118 168.696 252.174 168.487 252.174 168.203C252.174 168.138 252.168 168.024 252.156 167.86C252.147 167.693 252.137 167.52 252.125 167.341L253.022 167.236L253.101 168.321C253.116 168.535 253.171 168.708 253.268 168.84C253.365 168.969 253.513 169.033 253.712 169.033ZM258.019 171.332L258.722 170.633L259.425 171.332L258.722 172.035L258.019 171.332ZM255.843 170V169.033H256.56C256.917 169.033 257.25 168.995 257.557 168.919C257.868 168.843 258.183 168.734 258.502 168.594C258.821 168.453 259.174 168.283 259.561 168.084L259.891 167.913C259.832 167.895 259.762 167.869 259.68 167.833C259.601 167.795 259.458 167.735 259.253 167.653C258.955 167.53 258.71 167.435 258.52 167.368C258.329 167.3 258.191 167.267 258.106 167.267C257.957 167.267 257.809 167.312 257.663 167.403C257.519 167.491 257.396 167.601 257.293 167.732L257.131 167.943L256.318 167.539L256.432 167.346C256.62 167.032 256.858 166.782 257.148 166.594C257.441 166.404 257.762 166.309 258.111 166.309C258.307 166.309 258.52 166.35 258.748 166.432C258.977 166.511 259.221 166.613 259.482 166.739C259.801 166.895 260.075 167.019 260.304 167.113C260.532 167.204 260.739 167.271 260.923 167.315C261.111 167.359 261.301 167.385 261.495 167.394L261.486 168.304C261.339 168.321 261.194 168.354 261.051 168.4C260.907 168.444 260.734 168.515 260.532 168.611C260.333 168.705 260.074 168.837 259.754 169.007C259.397 169.194 259.05 169.364 258.713 169.517C258.376 169.666 258.03 169.785 257.676 169.873C257.324 169.958 256.948 170 256.546 170H255.843Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainPic);
export default __webpack_public_path__ + "static/media/main-pic.811ddb8bd2454db74efd2a7e2f786667.svg";
export { ForwardRef as ReactComponent };